import { showUpgradeDialog } from '@/shared/atom/showUpgradeDialogAtom';
import { getIsOnPaidPlan } from '@/shared/atom/teamBillingAtom';

/**
 * Exporting a file (Excel, CSV, or Quadratic .grid) is a paid-plan feature.
 *
 * Returns true when the current team is on a paid plan and the export may
 * proceed. For free teams it opens the upgrade dialog and returns false, so
 * callers triggered outside the export dialog (command palette, context menu,
 * keyboard shortcut) cannot bypass the paywall.
 */
export const canExportOrUpsell = (): boolean => {
  if (getIsOnPaidPlan()) {
    return true;
  }
  showUpgradeDialog('ExportDialog');
  return false;
};
